module.exports = __webpack_public_path__ + "static/media/preAssessment2.5a899283.png";